import { PARTNER } from 'scenes/CustomAudiences/LookalikeAudiences/components/LookalikeAudienceForm/constants';
import {
  FACEBOOK,
  SNAPCHAT,
  TIKTOK,
  DEV,
} from 'scenes/CustomAudiences/constants';

import FacebookPartnerAudienceBased from './Facebook';
import { validationSchema as FacebookPartnerAudienceBasedValidationSchema } from './Facebook/schemas';
import SnapchatPartnerAudienceBased from './Snapchat';
import { validationSchema as SnapchatPartnerAudienceBasedValidationSchema } from './Snapchat/schemas';
import TikTokPartnerAudienceBased from './TikTok';
import { validationSchema as TikTokPartnerAudienceBasedValidationSchema } from './TikTok/schemas';
import DevPartnerAudienceBased from './Dev';
import { validationSchema as DevPartnerAudienceBasedValidationSchema } from './Dev/schemas';

export const getCurrentComponent = (values) => {
  switch (values[PARTNER]) {
    case FACEBOOK:
      return FacebookPartnerAudienceBased;
    case TIKTOK:
      return TikTokPartnerAudienceBased;
    case SNAPCHAT:
      return SnapchatPartnerAudienceBased;
    case DEV:
      return DevPartnerAudienceBased;
    default:
      return () => null;
  }
};

export const getCurrentValidationSchema = (values) => {
  switch (values[PARTNER]) {
    case FACEBOOK:
      return FacebookPartnerAudienceBasedValidationSchema;
    case TIKTOK:
      return TikTokPartnerAudienceBasedValidationSchema;
    case SNAPCHAT:
      return SnapchatPartnerAudienceBasedValidationSchema;
    case DEV:
      return DevPartnerAudienceBasedValidationSchema;
    default:
      return () => null;
  }
};
